const WmAuth = {};
WmAuth.isAddAdmin = (state, addGroups) => {
  const data = state.userGroups;
  const hasGroups = addGroups.length > 0;
  return hasGroups && (WmAuth.isSuperAdmin(state) || data && data.some(r => addGroups.includes(r)));
};
WmAuth.isEditAdmin = (state, editGroups) => {
  const data = state.userGroups;
  const hasGroups = editGroups.length > 0;
  return hasGroups && (WmAuth.isSuperAdmin(state) || data && data.some(r => editGroups.includes(r)));
};
WmAuth.isBulkAdmin = (state, bulkGroups) => {
  const data = state.userGroups;
  const hasGroups = bulkGroups.length > 0;
  return hasGroups && (WmAuth.isSuperAdmin(state) || data && data.some(r => bulkGroups.includes(r)));
};
WmAuth.isSuperAdmin = state => state.userGroups && state.userGroups.includes('otto_admin');
WmAuth.isBulk = state => WmAuth.isBulkAdmin() && state.bulk === true;
export default WmAuth;